<div fxFlex="grow">
  <recrewt-image-selection-dialog-button #imgInput
    (imageSelected)="onImageSelected($event)"
    (delete)="onDelete()"
    [firstChange]="!imageUrl || imageUrl === DEFAULT_URL"
    style="display: none"
   />
  <div [class.inline]="appearance !== 'banner'" class="img-container">
    <div>
      @if (imageUrl !== DEFAULT_URL || appearance !== 'banner') {
        <img
          [class.banner]="appearance === 'banner'"
          [class.circle]="appearance === 'circle'"
          [height]="size"
          [src]="imageUrl! | safe: 'resourceUrl'"
          [width]="size"
          alt="Image upload"
          class="img-input b-rad-1"
          />
      } @else {
        <div
          [ngStyle]="{ height: size + 'px', width: appearance !== 'banner' ? size + 'px' : 2.5 * size + 'px' }"
          class="banner-placeholder b-rad-1"
          fxLayoutAlign="center center"
          >
          <img class="b-rad-1" [height]="size / 1.25" [src]="DEFAULT_URL" alt="" />
        </div>
      }
    </div>
    <div
      (click)="imgInput.click()"
      [class.banner]="appearance === 'banner'"
      [class.circle]="appearance === 'circle'"
      [ngStyle]="{ height: size + 'px', width: appearance !== 'banner' ? size + 'px' : '100%' }"
      class="after b-rad-1"
      fxLayout="column"
      fxLayoutAlign="center center"
      >
      <mat-icon>{{ icon }}</mat-icon>
      <p class="mat-caption no-pad">{{ hint | translate }}</p>
    </div>
  </div>
</div>

